"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crop = void 0;

var _RgbaImageBuffer = _interopRequireDefault(require("../RgbaImageBuffer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Returns an image buffer of the given region of the given buffer
 *
 * @param {RgbaImageBuffer} imgBuffer Buffer of the image to crop
 * @param {Object} region Region specifying where to crop the given buffer
 * @param {number} region.top Pixel in the y axis where the new image must start
 * @param {number} region.left Pixel in the x axis where the new image must
 * start
 * @param {number} region.height Height of the new image
 * @param {number} region.width Width of the new image
 */


var crop = function crop(imgBuffer) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$top = _ref.top,
      top = _ref$top === void 0 ? 0 : _ref$top,
      _ref$left = _ref.left,
      left = _ref$left === void 0 ? 0 : _ref$left,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? imgBuffer.height : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? imgBuffer.width : _ref$width;

  var resultPixels = new Uint8ClampedArray(height * width * _RgbaImageBuffer.default.NUM_CHANNELS);
  var currentIndex = 0;

  for (var yOffset = 0; yOffset < height; yOffset += 1) {
    for (var xOffset = 0; xOffset < width; xOffset += 1) {
      var pixel = imgBuffer.getPixel({
        x: left + xOffset,
        y: top + yOffset
      });
      resultPixels[currentIndex] = pixel[0];
      resultPixels[currentIndex + 1] = pixel[1];
      resultPixels[currentIndex + 2] = pixel[2];
      resultPixels[currentIndex + 3] = pixel[3];
      currentIndex += _RgbaImageBuffer.default.NUM_CHANNELS;
    }
  }

  return new _RgbaImageBuffer.default(width, height, resultPixels);
};

exports.crop = crop;